import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center'
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '31vh',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginLeft: '19%',
    overflowX: 'hidden',
    height: '57vh !important',
    position: 'relative',
  },
  inputEmail: {
    textTransform: 'lowercase',
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    background: '#fff',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '63px',
    paddingRight: '10px',
    marginBottom: '19px',
  },
  headFilter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonClose: {
    background: 'none',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
  },
  filtersBox: {
    position: 'absolute',
    marginTop: '172px',
    background: '#185b86',
    width: '315px',
    color: '#fff',
    padding: '10px',
    zIndex: '99',
    right: '0',
    marginRight: '9px',
    borderRadius: '5px',
  },
  labelFilter: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  buttonFilter: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    width: '120px',
    padding: '8px 0',
    marginTop: '9px',
    borderRadius: '2px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  button: {
    width: '16%',
    backgroundColor: '#026894',
    color: '#FFF',
    paddingTop: '2px',
    paddingBottom: '2px',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    borderRadius: '8px',
    marginLeft: '16px',
    height: '35px',
  },
  buttonVisualize: {
    marginRight: '16px',
  },
  searchContainer: {
    alignItems: 'center',
  },
}));

export default useStyles;
